import type { TransportType } from '../types';

interface TransportToggleProps {
  value: TransportType | '';
  onChange: (value: TransportType) => void;
  size?: 'sm' | 'md';
  /**
   * Freeze the toggle (lot A2-CAP). Only pass it where the toggle PERSISTS the
   * choice (RiderPage writes `rider.transport`); on the config pages it only
   * switches a local, per-page mode and must stay clickable. Defaults to false.
   */
  disabled?: boolean;
}

export default function TransportToggle({ value, onChange, size = 'md', disabled = false }: TransportToggleProps) {
  const baseClass = size === 'sm' ? 'toggle-group toggle-group-sm' : 'toggle-group';

  return (
    <div className={baseClass}>
      <button
        className={`toggle-btn ${value === 'van' ? 'active' : ''}`}
        onClick={() => onChange('van')}
        type="button"
        disabled={disabled}
      >
        🚐 Van
      </button>
      <button
        className={`toggle-btn ${value === 'tourbus' ? 'active' : ''}`}
        onClick={() => onChange('tourbus')}
        type="button"
        disabled={disabled}
      >
        🚌 Tourbus
      </button>
      <button
        className={`toggle-btn ${value === 'train' ? 'active' : ''}`}
        onClick={() => onChange('train')}
        type="button"
        disabled={disabled}
      >
        🚆 Train
      </button>
      <button
        className={`toggle-btn ${value === 'plane' ? 'active' : ''}`}
        onClick={() => onChange('plane')}
        type="button"
        disabled={disabled}
      >
        ✈️ Plane
      </button>
    </div>
  );
}